import { CONFIG } from '@h2h/shared';

const { DIVISION_SIZE, PROMOTE_COUNT, RELEGATE_COUNT } = CONFIG;
const BASE = CONFIG.COMBO.BASE_POINTS;
const MAX_LEGS = CONFIG.COMBO.MAX_LEGS;
const TIER_COUNT = CONFIG.TIERS.length;

/** Apply factual copy and remove fabricated stats from the design-export HTML. */
export function prepareWelcomeHtml(raw: string, brandIconUrl: string): string {
  let html = raw.replaceAll('__BRAND_ICON__', brandIconUrl);

  const replacements: Array<[string, string]> = [
    [
      'Call the exact score on the matches you care about, stake your confidence to multiply points, and battle your friends up six divisions. Free to play — from the World Cup to the Premier League and beyond.',
      `Back the matches you fancy — as many as you like. On each, call the result (1X2) for a ${BASE}-point base, then stack up to ${MAX_LEGS} boosts that multiply it. Miss the result and the card busts to −${BASE}. Free to play, no real money. World Cup 2026 is live; domestic leagues return when their seasons start.`
    ],
    [
      '<span style="font-size:11px;font-weight:800;color:#06291A;background:#24C56A;border-radius:999px;padding:4px 9px;">48 nations</span>',
      '<span style="font-size:11px;font-weight:800;color:#06291A;background:#24C56A;border-radius:999px;padding:4px 9px;">48 teams</span>'
    ],
    [
      '<div style="margin-top:32px; max-width:480px;">',
      '<div style="margin-top:32px; max-width:480px;" data-landing-auth>'
    ],
    [
      'Join the World Cup pool',
      'Play World Cup 2026'
    ],
    [
      '1</div><div style="font-size:12.5px;font-weight:600;color:rgba(255,255,255,0.5);margin-top:2px;">global leaderboard</div>',
      `${TIER_COUNT}</div><div style="font-size:12.5px;font-weight:600;color:rgba(255,255,255,0.5);margin-top:2px;">division tiers</div>`
    ],
    [
      'Exact score = <span style="color:#24C56A;font-weight:800;">5 pts</span> · Result = 2 pts',
      `Result (1X2) = <span style="color:#24C56A;font-weight:800;">${BASE} pts</span> · Boosts multiply`
    ],
    [
      '★ ×3 stake',
      `★ stack up to ${MAX_LEGS} boosts`
    ],
    [
      'Every league you watch.<br><span style="color:#0A9A72;">One ladder that follows you.</span>',
      'Every league you watch.<br><span style="color:#0A9A72;">Separate ladders, same account.</span>'
    ],
    [
      'Predict the competitions you already love — your division travels with you across all of them, all season long.',
      'One login, but each competition is its own world — tier, rank and rivals are per league. Every round you race a fresh group; join late and you still only fight the players in your division.'
    ],
    [
      'Call three exact scores',
      'Build your card'
    ],
    [
      'Before kickoff, predict the final score of three fixtures. Nail it exactly for the big points — get the result for a steady haul.',
      `Back any matches you like before kick-off. On each, call the result (1X2) — that's your ${BASE}-point base — then add up to ${MAX_LEGS} boosts (both teams to score, over/under ${CONFIG.TOTAL_GOALS_LINE}, exact score, anytime scorer and more).`
    ],
    [
      'Multiply your boldest call',
      'Stack your boosts'
    ],
    [
      'Drop a confidence stake on the pick you believe in most. Get it right and the points triple. Get it wrong and the ladder remembers.',
      `Every boost carries a difficulty multiplier. Land the result AND your boosts and they all multiply your base. Land the result but miss a boost and it divides back down. Miss the result and the whole card busts to −${BASE}.`
    ],
    [
      'Finish a round high in your group of 25 and you\'re promoted. String it together and rise from Bronze all the way to Elite.',
      `Finish a round in the top ${PROMOTE_COUNT} of your group of ${DIVISION_SIZE} and you promote one tier. Bottom ${RELEGATE_COUNT} relegate. String it together from Bronze to Elite — the ladder resets every round, so late joiners stay fair.`
    ],
    [
      '>Head-to-head &amp; banter<',
      '>Head-to-head duels<'
    ],
    [
      'Spain · 1.1M players',
      'Spain · Season starts Aug 2026'
    ],
    [
      'Predict every match from the group stage to the final. Call upsets before they happen, stake your confidence on the big ties, and prove you saw it coming when your group chat said you were mad.',
      'Predict every match from the group stage to the final. Build a card on any match you fancy — call the result, then stack boosts to multiply your base — and climb your World Cup division when the round settles.'
    ],
    [
      'Spin up a private mini-league for your group chat, office, or five-a-side team. Go head-to-head week on week, watch points land live, and let the table do the trash-talking.',
      'Spin up a private mini-league for friends, your office, or your five-a-side team. Season points stack on the vanity table — promotion and relegation still only happen in your official division.'
    ],
    [
      'HeadToHead is a free, per-league football prediction game — pick fixtures, stake your confidence and climb the divisions.',
      'HeadToHead is a free, per-league football prediction game — build prediction cards, stack boosts and climb the divisions.'
    ],
    [
      'Confidence stake on England',
      'England to win + boosts'
    ],
    [
      '>Confidence stake<',
      '>Boost stack<'
    ],
    [
      'Weekly duels, rivalries, and a chat that never quiets down.',
      'Challenge a friend for the round — same picks, same scoring, straight score comparison.'
    ],
    [
      'Points update as the goals go in — feel the table move.',
      'Division standings update when the round settles — promotion and relegation hit after the last whistle.'
    ],
    [
      'The Office Pundits ⚽',
      'Friends league ⚽'
    ],
    [
      'Priya S.',
      'Alex'
    ],
    [
      'Marcus A.',
      'Sam'
    ],
    [
      'Jonas K.',
      'Jordan'
    ],
    [
      '+235 this round',
      'Round pts'
    ],
    [
      '+198 this round',
      'Round pts'
    ],
    [
      '+186 this round',
      'Round pts'
    ],
    [
      '+154 this round',
      'Round pts'
    ],
    [
      '1,840',
      '—'
    ],
    [
      '1,795',
      '—'
    ],
    [
      '1,742',
      '—'
    ],
    [
      '1,701',
      '—'
    ],
    [
      '"Called it 💚 see you in Gold"',
      '"Example banter chip"'
    ],
    [
      'England · 2.4M players',
      'England · Season starts Aug 2026'
    ],
    [
      'Spain · 1.1M players',
      'Spain · Season starts Aug 2026'
    ],
    [
      'Italy · 680K players',
      'Italy · Season starts Aug 2026'
    ],
    [
      'Denmark · 120K players',
      'Denmark · Season starts Jul 2026'
    ],
    [
      '48 nations',
      '48 teams'
    ],
    [
      'nations in the draw',
      'teams in the draw'
    ],
    [
      'Also in play &amp; landing soon',
      'More sports later'
    ],
    [
      'href="#top" style="font-size:13.5px;font-weight:600;color:rgba(255,255,255,0.72);text-decoration:none;">About</a>',
      'href="/about.html" style="font-size:13.5px;font-weight:600;color:rgba(255,255,255,0.72);text-decoration:none;">About</a>'
    ],
    [
      'href="#top" style="font-size:13.5px;font-weight:600;color:rgba(255,255,255,0.72);text-decoration:none;">Support</a>',
      'href="/support.html" style="font-size:13.5px;font-weight:600;color:rgba(255,255,255,0.72);text-decoration:none;">Support</a>'
    ],
    [
      'href="#top" style="font-size:13.5px;font-weight:600;color:rgba(255,255,255,0.72);text-decoration:none;">Privacy</a>',
      'href="/privacy.html" style="font-size:13.5px;font-weight:600;color:rgba(255,255,255,0.72);text-decoration:none;">Privacy</a>'
    ],
    [
      'href="#top" style="font-size:13.5px;font-weight:600;color:rgba(255,255,255,0.72);text-decoration:none;">Terms</a>',
      'href="/terms.html" style="font-size:13.5px;font-weight:600;color:rgba(255,255,255,0.72);text-decoration:none;">Terms</a>'
    ],
    [
      'Pick score',
      'Add pick'
    ],
    [
      'Locks in 3h 08m',
      'Locks at kickoff'
    ],
    [
      'ENG 2–1 FRA',
      'Live scores'
    ],
    [
      '78\'',
      ''
    ],
    [
      'Triples the points on your boldest call',
      `Every boost you land multiplies your ${BASE}-point base`
    ],
    [
      'One login syncs your picks, points and divisions across iPhone, Android and desktop — instantly.',
      'One login syncs your account across iPhone, Android and desktop. Each league keeps its own tier and division board.'
    ]
  ];

  for (const [from, to] of replacements) {
    html = html.replaceAll(from, to);
  }

  // Remove fabricated social proof (stars, 4.8, 2.4M players).
  html = html.replace(
    /<!-- social proof -->[\s\S]*?<!-- RIGHT : app mock -->/,
    `<!-- social proof -->
        <p style="font-size:13px;font-weight:600;color:#8A8A92;margin-top:30px;">Free to play · No real money · iPhone, Android &amp; browser</p>
      </div>

      <!-- RIGHT : app mock -->`
  );

  // Remove fake rating chips and player-count badge in hero mock area.
  html = html.replace(
    /<div style="width:36px;height:36px;border-radius:50%;background:#15151B;border:2\.5px solid #F4F4F7;display:grid;place-items:center;font-size:10px;font-weight:800;color:#24C56A;margin-left:-12px;">\+2M<\/div>/,
    ''
  );
  html = html.replace(
    /<div style="position:absolute; right:-18px; top:64px;[\s\S]*?<\/div>\s*<!-- floating android chip -->/,
    '<!-- floating android chip -->'
  );
  html = html.replace(
    /<div style="display:flex; align-items:center; justify-content:center; gap:8px; margin-top:20px;">[\s\S]*?<\/div>\s*<\/div>\s*<\/div>\s*<\/section>\s*\n\s*<!-- ============================================================ -->\s*\n\s*<!-- FOOTER -->/,
    `<p style="font-size:13.5px;font-weight:600;color:rgba(255,255,255,0.85);margin-top:20px;">Free · No real money · iPhone, Android &amp; desktop</p>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================ -->
  <!-- FOOTER -->`
  );

  // Mark UI mockups as illustrative.
  html = html.replace(
    'headtohead.com/world-cup',
    'headtohead.com · example UI'
  );
  html = html.replace(
    '<div style="font-family:\'Space Grotesk\',sans-serif;font-size:11px;font-weight:700;color:#9A9AA4;letter-spacing:0.06em;text-transform:uppercase;">Mini-league</div>',
    '<div style="font-family:\'Space Grotesk\',sans-serif;font-size:11px;font-weight:700;color:#9A9AA4;letter-spacing:0.06em;text-transform:uppercase;">Example mini-league</div>'
  );

  // Premier League / La Liga / Serie A / Superliga: not live yet (only World Cup is).
  html = html.replaceAll(
    '<span style="display:inline-flex;align-items:center;gap:6px;background:rgba(36,197,106,0.12);border-radius:999px;padding:5px 10px;"><span style="width:6px;height:6px;border-radius:50%;background:#24C56A;animation:h2hpulse 1.4s ease-in-out infinite;"></span><span style="font-size:10px;font-weight:800;color:#0A9A72;">LIVE</span></span>',
    '<span style="display:inline-flex;align-items:center;gap:6px;background:rgba(154,154,164,0.12);border-radius:999px;padding:5px 10px;"><span style="font-size:10px;font-weight:800;color:#9A9AA4;">SOON</span></span>'
  );

  // World Cup card in coverage row should stay LIVE — re-fix first league cards only.
  // The WC section already has its own badge; coverage PL/LL/SA/SL all got SOON which is correct.

  // Marquee: repeat the football set so the scrolling track always exceeds the
  // viewport and loops seamlessly. The CSS animation shifts the track by 50%,
  // so an even number of copies keeps the loop continuous with no black gaps.
  const MARQUEE_COPIES = 6;
  html = html.replace(/<!-- marquee:start -->([\s\S]*?)<!-- marquee:end -->/, (_m, unit) => {
    const one = unit.trim();
    return `\n      ${Array.from({ length: MARQUEE_COPIES }, () => one).join('\n      ')}\n      `;
  });

  // Coverage: drop non-football sport cards; keep the “More every season” tile.
  html = html.replace(
    /<div style="display:grid; grid-template-columns:repeat\(auto-fit,minmax\(150px,1fr\)\); gap:12px; margin-top:16px;">[\s\S]*?<div style="display:flex; align-items:center; justify-content:center; gap:9px; background:#15151B; border-radius:14px; padding:13px 15px;">[\s\S]*?<\/div>\s*<\/div>/,
    `<div style="display:grid; grid-template-columns:repeat(auto-fit,minmax(150px,1fr)); gap:12px; margin-top:16px;">
        <div style="display:flex; align-items:center; justify-content:center; gap:9px; background:#15151B; border-radius:14px; padding:13px 15px;">
          <span style="font-size:13.5px;font-weight:700;color:#fff;">More football leagues every season</span>
        </div>
      </div>`
  );

  // Mini-league mock: illustrative badge, not a live feed.
  html = html.replace(
    '<span style="font-size:11px;font-weight:800;color:#24C56A;">LIVE</span>',
    '<span style="font-size:11px;font-weight:800;color:#9A9AA4;">EXAMPLE</span>'
  );

  // Add LIVE badge to World Cup in coverage — insert after WC26 block in first PL card... 
  // Actually WC is separate in marquee; coverage section only has domestic leagues with SOON - good.

  // Example-only floating points chip.
  html = html.replace(
    '<span style="font-family:\'Space Grotesk\',sans-serif;font-size:30px;font-weight:700;color:#0A9A72;letter-spacing:-0.03em;line-height:1;font-variant-numeric:tabular-nums;">+235</span>',
    '<span style="font-family:\'Space Grotesk\',sans-serif;font-size:14px;font-weight:700;color:#0A9A72;letter-spacing:-0.01em;line-height:1;">Example</span>'
  );

  // App Store IP compliance (guidelines 5.2.1 / 4.1(a)): the in-app competition is
  // branded generically — never with FIFA's protected "World Cup" mark, and with no
  // year tying it to the live FIFA tournament. Sweep every remaining reference in the
  // design-export HTML and the injected copy above so a single place keeps the whole
  // landing page clean. Order matters: collapse "World Cup" first, then any leftover
  // "World Tournament", then strip a trailing year off the generic name.
  html = html.replaceAll('World Cup', 'Football Tournament');
  html = html.replaceAll('World Tournament', 'Football Tournament');
  html = html.replaceAll('Football Tournament 2026', 'Football Tournament');
  html = html.replaceAll('WC26', 'FT');

  // Guideline 4.1(a): no third-party league trademarks in the shipped page. Use the
  // same generic country-league names the app renders from `league.name`.
  html = html.replaceAll('Premier League', 'England League');
  html = html.replaceAll('La Liga', 'Spain League');
  html = html.replaceAll('Serie A', 'Italy League');
  html = html.replaceAll('Superliga', 'Denmark League');

  return html;
}
